import styled from 'styled-components';
import Button from 'products/nomad_insurance/components/Button';
import { th } from 'style/theme';

export const HighlightBox = styled.div`
  padding: 16px;
  border-radius: 24px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  background-color: ${th('colors.fountainBlue+3')};

  > ul {
    padding-left: 20px;
    margin: 0;
  }
`;

export const Paragraph = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
`;

export const CloseButton = styled(Button)`
  margin-left: auto;
`;
